import React, { Component } from "react"
import MetaTags from 'react-meta-tags';
import PropTypes from 'prop-types'
import { Link } from "react-router-dom"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import {  map, isEmpty, size } from "lodash";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Formik, Field, Form, ErrorMessage, FieldArray } from "formik";
import * as Yup from "yup";
import Moment from 'react-moment';
import "flatpickr/dist/themes/material_blue.css"
import Flatpickr from "react-flatpickr"
import Swal from 'sweetalert2'
import classnames from "classnames"
import PlacesAutocomplete, { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import deleteIcon from "../../assets/images/icons/bin.png";
import pointerDown from "../../assets/img/pointer-down.png"
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Collapse,
  CardHeader,
    Table,
    Alert
} from "reactstrap"
import { API_URL } from "helpers/api_url";
import { get, post, put, del } from "helpers/api_helper";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
class Deals extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deals:[],
      loading: true,
      activeTab3: "5",
      activeCategories: {},
      checkedTasks: {},
      offerDetail: {}
    }
   
    this.toggleManage = this.toggleManage.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.handleSubmitLowyer =   this.handleSubmitLowyer.bind(this);
    this.handleSubmitMortgage = this.handleSubmitMortgage.bind(this);
    this.t_col9 = this.t_col9.bind(this);
    this.t_col10 = this.t_col10.bind(this);
    this.t_col11 = this.t_col11.bind(this);
  }
  toggleCategory = (category) => {
    this.setState((prevState) => ({
      activeCategories: {
        ...prevState.activeCategories,
        [category]: !prevState.activeCategories[category],
      },
    }));
  };
  t_col9() {
    this.setState({
      col9: !this.state.col9,
      col10: false,
      col11: false,
    });
  }

  t_col10() {
    this.setState({
      col10: !this.state.col10,
      col9: false,
      col11: false,
    });
  }

  t_col11() {
    this.setState({
      col11: !this.state.col11,
      col9: false,
      col10: false,
    });
  }
  toggle3(tab) {
    if (this.state.activeTab3 !== tab) {
      this.setState({
        activeTab3: tab,
      });
    }
  }
  getBuyerType = (type) => {
    if(type==1)
      return 'Looking to Rent';
    else if(type==2)
    return 'Looking to Buy';
    
  }

  getSellerType = (type) => {
    if(type==1)
      return 'Looking to Sell';
    else if(type==2)
    return 'Looking to Lease';
    
  }
  getCommType = (type) => {
    if(type==3)
      return 'Fixed';
    else if(type==4)
    return '%';
    else
    return 'N/A';
    
  }

  getStatus = (status) => {
    if(status==1)
      return 'In-progress';
    else if(status==2)
    return 'Completed';
    else if(status==3)
        return 'Cancelled';
    else if(status==4)
        return 'Fell through ';
    else
    return 'Pending';
    
  }
 
  componentDidMount() {
    this.fetchDeals();
  }
    
  fetchDeals(){
      const params = {
        clientId: localStorage.getItem("userId"),
        agentId: localStorage.getItem("agentId"),
      };
      get(`ClientEngagement/all`, { params })
      .then((response) => {
        this.setState({ deals: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  handleDealTypeChange = (e) => {
    this.setState({ dealType: e.target.value });
  };
  getFilteredDeals = () => {
    const { dealType } = this.state;
    const { deals } = this.state;
    if (dealType === "") return deals;

    return deals.filter((deal) => {
      switch (dealType) {
        case "0": return deal.isBuyer && deal.buyerType === 2;
        case "1": return deal.isBuyer && deal.buyerType === 1;
        case "2": return deal.isSeller && deal.sellerType === 1;
        case "3": return deal.isSeller && deal.sellerType === 2;
        case "4": return deal.isInvestor;
        default: return true;
      }
    });
  };
  fetchBuyerClosingChecklist(){
      const params = {
        forType: 1,
        agentId: localStorage.getItem("agentId"),
        propertyType:0,
        clientId: localStorage.getItem('userId')
      };
      get(`ClientClosingCheckList/allforagenttype`, { params })
      .then((response) => {
        this.setState({ closingChecklist: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchSellerClosingChecklist(){
      const params = {
        forType: 2,
        agentId: localStorage.getItem("agentId"),
        propertyType:0,
        clientId: localStorage.getItem('userId')
      };
      get(`ClientClosingCheckList/allforagenttype`, { params })
      .then((response) => {
        this.setState({ closingChecklist: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  fetchMortgageContact(dealId){
      const params = {
        dealId: dealId,
        agentId: localStorage.getItem("agentId"),
        clientId:localStorage.getItem("userId")
      };
      get(`ClientProfessionalContactExt/get_client_mortgage_contactdeal`, { params })
      .then((response) => {
        this.setState({ mortgageContact: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  fetchLegalContact(dealId){
      const params = {
        dealId: dealId,
        agentId: localStorage.getItem("agentId"),
        clientId:localStorage.getItem("userId")
      };
      get(`ClientProfessionalContactExt/get_client_legal_contactdeal`, { params })
      .then((response) => {
        this.setState({ legalContact: response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  toggle() {
    this.setState(prevState => ({
        isRight: !prevState.isRight,
        activeTab3: !prevState.isRight ? "5" : prevState.activeTab3,
    }));
  }
  toggleManage() {
  this.setState({ isRight: !this.state.isRight,  });
  //this.toggle();
 }

 fetchBuyerListing(listingId) {
  get(`AgentClientPotentialListing/${listingId}`)
    .then((response) => {
      this.setState({ buyerListing: response, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}

fetchSellerListing(listingId) {
  get(`ClientSellerShowing/byid?sellerShowingId=${listingId}`)
    .then((response) => {
      this.setState({ sellerListing: response, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}

fetchInvestorListing(listingId) {
  const params = {
    agentId: localStorage.getItem("agentId"),
    clientId: localStorage.getItem("userId"),
    selectedOptionId: listingId
  };
  get(`ProjectCampaignClient/projectselectedoption`, { params })
    .then((response) => {
      this.setState({ investorListing: response, loading: false });
    })
    .catch((error) => {
      this.setState({ error: error.message, loading: false });
    });
}
toggleManage = arg => {
const deal = arg;
this.setState({
  deal: {
        id: deal?.id,
        clientEngagementId: deal?.id,
        clientEngagementGuId: deal?.clientEngagementId,
        contactName: deal?.contactName,
        contactAddress: deal?.contactAddress,
        clientEngagementStatus: deal?.clientEngagementStatus,
        commissionTypeId: deal?.commissionTypeId,
        commissionValue: deal?.commissionValue,
        closingDate: deal?.closingDate,
        startDate: deal?.startDate,
        endDate: deal?.endDate,
        lastAgreementDate: deal?.lastAgreementDate,
        propertyAddress: deal?.propertyAddress,
        transactionAmount: deal?.transactionAmount,
        commissionValue: deal?.commissionValue,
        isBuyer: deal?.isBuyer,
        isSeller: deal?.isSeller,
        isInvestor: deal?.isInvestor,
        buyerType: deal?.buyerType,
        sellerType: deal?.sellerType,

        agentName: deal?.agentName,
        agentOfficeName: deal?.agentOfficeName,
        agentMobile: deal?.agentMobile,
        agentEmail: deal?.agentEmail,
        clientName:deal?.clientName,
        clientMobile: deal?.clientMobile,
        clientEmail: deal?.clientEmail,
        clinetPhone: deal?.clientPhone,
        secondaryClientName: deal?.secondaryClientName,
        secondaryClientEmail: deal?.secondaryClientEmail,
        secondaryClientMobile: deal?.secondaryClientMobile,
        secondaryClientPhone: deal?.secondaryClientPhone,
        dealRefId:deal?.dealRefId,
        currencyCode: deal?.currencyCode
}
});
if(deal?.isBuyer){
  this.fetchBuyerClosingChecklist();
  this.fetchBuyerDealChecklist(deal?.id);
  if(deal?.dealRefId){
    this.fetchBuyerListing(deal?.dealRefId);
  }
  this.getBuyerOffer(deal?.id);
}else if(deal?.isSeller){
  this.fetchSellerClosingChecklist();
  this.fetchSellerChecklist(deal?.id);
  if(deal?.dealRefId){
    this.fetchSellerListing(deal?.dealRefId);
  }
  this.getSellerffer(deal?.id);
}else if(deal?.isInvestor){
  this.fetchInvestorListing(deal?.dealRefId);
  this.fetchPayments(deal?.id)
}
this.fetchMortgageContact(deal?.id);
this.fetchLegalContact(deal?.id);
this.toggle();
}
 handlePlaceSelected = (address, setFieldValue) => {
    geocodeByAddress(address)
      .then(results => {
        const place = results[0];
        const addressComponents = place.address_components;
        
        const getComponent = (types) => {
          const component = addressComponents.find((component) =>
            types.every((type) => component.types.includes(type))
          );
          return component ? component.long_name : '';
        };

        const streetNumber = getComponent(['street_number']);
        const route = getComponent(['route']);
        const city = getComponent(['locality', 'political']);
        const province = getComponent(['administrative_area_level_1', 'political']);
        const postalCode = getComponent(['postal_code']);
        const country = getComponent(['country', 'political']);

        const modifiedAddress = `${streetNumber} ${route}`;
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        console.log(modifiedAddress)
        setFieldValue(`fullAddress`, place.formatted_address);
        setFieldValue(`addressLine1`, modifiedAddress);
        setFieldValue(`addressLine2`, city);
        setFieldValue(`city`, city);
        setFieldValue(`province`, province);
        setFieldValue(`postal`, postalCode);
        setFieldValue(`country`, country);
        setFieldValue(`longitude`, longitude);
        setFieldValue(`latitude`, latitude);

      })
      .catch(error => console.error('Error', error));
  };
 handleSubmitLowyer = async (values, { setSubmitting, resetForm }) => {
  try {
    const payload = {
        id:values.id,
        clientProfessionalContactId:values.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
        primaryContactId:values.primaryContactId || 0,
        addressId:values.addressId || 0,
        isActive:true,
        dealId: values.dealId,
        title:values.title,
        notes:values.notes,
        professionalContactTypeId: values.professionalContactTypeId,
        contactFName: values.contactFName,
        contactLName: values.contactLName,
        contactName: `${values.contactFName} ${values.contactLName}`,
        clientId: parseInt(values.clientId),
        agentId: parseInt(values.agentId),
        organizationName: values.organizationName,
        email: values.email,
        phone: values.phone,
        mobile: values.mobile,
       
        fullAddress:values.fullAddress,
        addressLine1:values.addressLine1,
        addressLine2:values.addressLine2,
        nearestIntersection:values.nearestIntersection,
        city:values.city,
        province:values.province,
        postal:values.postal,
        country:values.country,
        longitude:values.longitude,
        latitude:values.latitude,   
    }
    const apiUrl = values.id !== 0
    ? `ClientProfessionalContactExt/update_client_legal_contact`
    : `ClientProfessionalContactExt/add_client_legal_contact`;
toast.loading("Please wait...");
  const response = values.id !== 0 
    ? await put(apiUrl, payload)
    : await post(apiUrl, payload);
    if (response) {
      toast.dismiss();
      toast.success("Legal contact updated successfully!");
      this.toggle();
    }
  } catch (error) {
    console.error("Error submitting form:", error);
    
  } finally {
    setSubmitting(false);
  }
  };
  handleSubmitMortgage = async (values, { setSubmitting, resetForm }) => {
    try {
      const payload = {
          id:values.id,
          clientProfessionalContactId:values.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
          primaryContactId:values.primaryContactId || 0,
          addressId:values.addressId || 0,
          isActive:true,
          dealId: values.dealId,
          title:values.title,
          notes:values.notes,
          professionalContactTypeId: values.professionalContactTypeId,
          contactFName: values.contactFName,
          contactLName: values.contactLName,
          contactName: `${values.contactFName} ${values.contactLName}`,
          clientId: parseInt(values.clientId),
          agentId: parseInt(values.agentId),
          organizationName: values.organizationName,
          email: values.email,
          phone: values.phone,
          mobile: values.mobile,
         
          fullAddress:values.fullAddress,
          addressLine1:values.addressLine1,
          addressLine2:values.addressLine2,
          nearestIntersection:values.nearestIntersection,
          city:values.city,
          province:values.province,
          postal:values.postal,
          country:values.country,
          longitude:values.longitude,
          latitude:values.latitude,   
      }
      const apiUrl = values.id !== 0
      ? `ClientProfessionalContactExt/update_client_mortgage_contact`
      : `ClientProfessionalContactExt/add_client_mortgage_contact`;

    toast.loading("Please wait...");
    const response = values.id !== 0 
      ? await put(apiUrl, payload)
      : await post(apiUrl, payload);
      if (response) {
      toast.dismiss();
      toast.success("Mortgage contact updated successfully!");
      this.toggle();
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      
    } finally {
      setSubmitting(false);
    }
  };
  handleCheck = (taskId) => {
    this.setState((prevState) => ({
      checkedTasks: {
        ...prevState.checkedTasks,
        [taskId]: !prevState.checkedTasks[taskId],
      },
    }));
  };
  handleBuyerClosingCheckSubmit = (event) => {
    event.preventDefault(); 
  
    const selectedTasks = Object.entries(this.state.checkedTasks)
      .filter(([_, isChecked]) => isChecked) 
      .map(([taskId]) => ({
        clientClosingCheckListId: parseInt(taskId, 10),
        clientListingId: 0,
        clientDealId: 0,
        clientId: parseInt(localStorage.getItem("userId")),
        agentId: parseInt(localStorage.getItem("agentId")),
        status: true,
        isActive: true,
      }));
  
    const payload = { buyerClosingCheckLists: selectedTasks };
  
    console.log("Submitting Data:", JSON.stringify(payload, null, 2));
  
   
  };
  fetchBuyerDealChecklist(dealId){
      const params = {
        DealId: dealId,
        ClientTypeId:1,
        ClientId:localStorage.getItem('userId'),
        AgentId:localStorage.getItem('agentId')
      };
      get(`ClientBuyerClosingCheckList/allfordeal`, { params })
      .then((response) => {
        const fetchedSelectedTasks = response.map(
          (task) => task.clientClosingCheckListId
        );
        const fetchedChecklistIds = response.map(
          (task) => task.id
        );
        this.setState({ 
          dealChecklists: response, 
          selectedChecklistIds: fetchedSelectedTasks,
          selectedTasks: fetchedChecklistIds,
          loading: false 
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  // fetchSellerChecklist(dealId){
  //   const obj = JSON.parse(localStorage.getItem("authUser"));
  //   const token = obj?.resultData?.bearerToken;
  //   const headers = {
  //       Authorization: `Bearer ${token}`, 
  //       "Content-Type": "application/json",
  //     };
  
  //     const params = {
  //       DealId: dealId,
  //       ClientTypeId: 2,
  //       ClientId: localStorage.getItem('userId'),
  //       AgentId:localStorage.getItem('agentId')
  //     };
  //     axios
  //     .get(`${API_URL}ClientSellerClosingCheckList/allfordeal`, { headers, params })
  //     .then((response) => {
  //       const fetchedSelectedTasks = response.data.map(
  //         (task) => task.clientClosingCheckListId
  //       );
  //       const fetchedChecklistIds = response.data.map(
  //         (task) => task.id
  //       );
  //       this.setState({ 
  //         dealChecklists: response.data, 
  //         selectedChecklistIds: fetchedSelectedTasks,
  //         selectedTasks: fetchedChecklistIds,
  //         loading: false 
  //       });
  //     })
  //     .catch((error) => {
  //       this.setState({ error: error.message, loading: false });
  //     });
  // } 
  fetchBuyerDealChecklist(dealId){
      const params = {
        DealId: dealId,
        ClientTypeId:1,
        ClientId:localStorage.getItem('userId'),
        AgentId:localStorage.getItem('agentId')
      };
      get(`ClientBuyerClosingCheckList/allfordeal`, { params })
      .then((response) => {
        const fetchedSelectedTasks = response.map(
          (task) => task.clientClosingCheckListId
        );
        const fetchedChecklistIds = response.map(
          (task) => task.id
        );
        this.setState({ 
          dealChecklists: response, 
          selectedChecklistIds: fetchedSelectedTasks,
          selectedTasks: fetchedChecklistIds,
          loading: false 
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  fetchSellerChecklist(dealId) {
    const params = {
      DealId: dealId,
      ClientTypeId: 2,
      ClientId: localStorage.getItem('userId'),
      AgentId: localStorage.getItem('agentId'),
    };
  
    get(`ClientSellerClosingCheckList/allfordeal`, { params })
      .then((response) => {
        const dealChecklists = response;
  
        const selectedTasks = dealChecklists.map(task => task.clientClosingCheckListId);
  
        const checklistIdMap = {};
        dealChecklists.forEach(task => {
          checklistIdMap[task.clientClosingCheckListId] = task.id;
        });
  
        this.setState({
          dealChecklists,
          selectedTasks,
          checklistIdMap,  
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
    handelSubmitPayment = async (values) => {
    try {
      const transformedValues = {
        agentClientTransactionPaymentSchedules: values.agentClientTransactionPaymentSchedules.map((item) => ({
          ...item,
          paymentAmount: parseInt(item.paymentAmount) || 0,
          paymentNotificationBeforeDays: parseInt(item.paymentNotificationBeforeDays) || 0,
          agentId: parseInt(item.agentId) || 0,
          clientId: parseInt(item.clientId) || 0,
          dealRefId: parseInt(item.dealRefId) || 0,
          engagementId: parseInt(item.engagementId) || 0,
          projectId: parseInt(item.projectId) || 0,
          paymentDate:moment(item.paymentDate).format("YYYY-MM-DD"),
        }))
      };
      toast.loading("Please wait...");
      const response = await post(
       `AgentClientTransactionPaymentSchedule/bulkadd`,
       transformedValues
      );
      if (response) {
        toast.dismiss();
        toast.success("Payment schedule submitted successfully!");
        this.toggle();
        //this.fetchPayments(this.state.transaction.id);
      } else {
        console.warn("Something went wrong!", response);
      }
    } catch (error) {
      console.error("Error submitting payment schedule:", error);
      // Show error message to user
    }
  };
   fetchPayments(TransactionId){
        const params = {
          TransactionId: TransactionId,
          ClientId: localStorage.getItem('userId'),
          AgentId:localStorage.getItem('agentId')
        };
        get(`AgentClientTransactionPaymentSchedule/allAgent`, { params })
        .then((response) => {
         
          this.setState({ 
            paymentLists: response, 
           
          });
        })
        .catch((error) => {
          this.setState({ error: error.message, loading: false });
        });
    }
    deletePayment = (payment) => {
      Swal.fire({
        title: "Are you sure?",
        text: "This action cannot be undone.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
         
          del(`AgentClientTransactionPaymentSchedule/${payment.id}`)
          .then((response) => {
            Swal.fire("Deleted!", "Payment Schedule has been deleted.", "success");
            this.fetchPayments(payment.engagementId);
          })
          .catch((error) => {
            Swal.fire("Error!", "An error occurred while deleting the payment.", "error");
          });
        }
      });
    }

   getBuyerOffer(refId){
      const params = {
        dealId: refId
      };
      get(`ClientOffer/GetAcceptedBuyerClientOffersByDealId`, { params })
      .then((response) => {
        this.setState({ offerDetail: Array.isArray(response) ? response[0] : response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }

  getSellerffer(refId){
      const params = {
        dealId: refId
      };
      get(`ClientOffer/GetAcceptedSellerClientOffersByDealId`, { params })
      .then((response) => {
        this.setState({ offerDetail: Array.isArray(response) ? response[0] : response, loading: false });
      })
      .catch((error) => {
        this.setState({ error: error.message, loading: false });
      });
  }
  render() {
   const { deals, deal, closingChecklist, mortgageContact, legalContact, buyerListing, sellerListing, investorListing, offerDetail} = this.state;
   console.log(this.state.selectedTasks);
   const groupedChecklist = closingChecklist?.reduce((acc, item) => {
    acc[item.checkListCategory] = acc[item.checkListCategory] || [];
    acc[item.checkListCategory].push(item);
    return acc;
  }, {});
 const startDate = deal?.lastAgreementDate ? new Date(deal?.lastAgreementDate) : null;
    const formattedDate = startDate
      ? `${startDate.getFullYear().toString().slice(-2)}${(startDate.getMonth() + 1).toString().padStart(2, '0')}`
      : "";
    const generatedDealId = deal?.id ? `${deal?.id}-${formattedDate}` : "";
    console.log(buyerListing);
    return (
      <React.Fragment>
        {this.props.loading && this.props.loading ? (
         <div className="loading">Loading&#8230;</div>
         ) : null}
        <ToastContainer autoClose={2000} />
       
        <div className="page-content">
          <MetaTags>
            <title>Seller Showings  | Realty Space</title>
          </MetaTags>
          <Container fluid>
             {/* <Breadcrumbs
              title={this.props.t("Seller")}
              breadcrumbItem={this.props.t("Seller Showings ")}
            /> */}
            <Row>
              
              
              <Col xl="12">
             <h5 className="card-title text-uppercase mb-4">Deals</h5>
			  <Row>
				<Col sm="12">
					 <Card className="rs-card-bg"> 
            <CardHeader>
                  <Row className="mb-2">
                        <Col sm="9">
                               
                              </Col>
                              <Col sm="3">
                                <select className="form-select select-filter" value={this.state.dealType} onChange={this.handleDealTypeChange}>
                                  <option value="">All Deals</option>
                                  <option value="0">Buyer - Purchase</option>
                                  <option value="1">Buyer - Rent </option>
                                  <option value="2">Seller - Sell </option>
                                  <option value="3">Seller - Lease</option>
                                  <option value="4">Investor</option>

                                </select></Col>
                             
                            </Row>
            </CardHeader>
                    <CardBody>
                    
				

          

                            <DataTable
                              className=""
                              stripedRows
                              //value={Array.isArray(deals) ? deals : deals ? [deals] : []}
                              value={this.getFilteredDeals()}
                              paginator
                              rows={10}
                              rowsPerPageOptions={[10, 20, 30, 50, 100, 150, 200, 500]}
                              currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                              tableStyle={{ minWidth: "50rem" }}
                            >
                              <Column
                                field="lastAgreementDate"
                                header="Start Date"
                                body={(rowData) =>
                                  rowData.lastAgreementDate ? <Moment format="MMM, DD YYYY">{rowData.lastAgreementDate}</Moment> : "N/A"
                                }
                              />

                              <Column field="clientName" header="Deal Id"
                                body={(rowData) => {
                                  const id = rowData.id || "N/A";
                                  const date = rowData.lastAgreementDate ? new Date(rowData.lastAgreementDate) : null;
                                  const formattedDate = date
                                    ? `${String(date.getFullYear()).slice(2)}${String(date.getMonth() + 1).padStart(2, "0")}`
                                    : "0000";
                                  return `${id}-${formattedDate}`;
                                }}
                              />
                              <Column field="contactName" header="Type" body={(rowData) => {
                                if (rowData.isBuyer) return `Buyer ${rowData.buyerType ? `- ${this.getBuyerType(rowData.buyerType)}` : ""}`;
                                if (rowData.isSeller) return `Seller ${rowData.sellerType ? `- ${this.getSellerType(rowData.sellerType)}` : ""}`;
                                if (rowData.isInvestor) return "Investor";
                                return "N/A";
                              }} />
                              <Column
                                field="transactionAmount"
                                header="Transaction Amount"
                                body={(rowData) => (
                                  <CurrencyFormat
                                    value={rowData?.transactionAmount || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={rowData.currencyCode ? rowData.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                                )}
                              />
                              {/* <Column field="transactionAmount" header="Transaction Amount" body={(rowData) => `$${rowData?.transactionAmount?.toFixed(2) || "0.00"}`} /> */}
                              <Column field="commissionTypeId" header="Commission Type" body={(rowData) => this.getCommType(rowData.commissionTypeId) || "N/A"} />
                              <Column field="commissionValue" header="Commission Value" body={(rowData) => {
                                  if (rowData.commissionTypeId === 3) {
                                    return `$${rowData.commissionValue?.toFixed(2) || "0.00"}`;
                                  }
                                  if (rowData.commissionTypeId === 4) {
                                    return `${rowData.commissionValue?.toFixed(2) || "0.00"} %`;
                                  }
                              }}
                                
                               />
                              <Column field="clientEngagementStatus" header="Status " body={(rowData) => {
                                if (rowData.clientEngagementStatus === 1) return `In-progress`;
                                if (rowData.clientEngagementStatus === 2) return `Completed`;
                                if (rowData.clientEngagementStatus === 3) return "Cancelled";
                                if (rowData.clientEngagementStatus === 4) return "Fell Through";
                                return "N/A";
                              }} />
                              <Column
                                field="action"
                                header="Action"
                                body={(rowData) => (
                                  <Link to="#" onClick={() => this.toggleManage(rowData)} className="btn btn-primary">
                                    Manage
                                  </Link>
                                )}
                              />
                            </DataTable>
					</CardBody>
					</Card>
				</Col>
			</Row>
			
			
            </Col>
            
            </Row>
           
          </Container>
          <Offcanvas
              isOpen={this.state.isRight}
              direction="end"
              toggle={this.toggleManage}
              style={{width:900}}
            >
              <OffcanvasHeader toggle={this.toggleManage}>
                Manage
              </OffcanvasHeader>
              <OffcanvasBody>
                <Nav pills className="navtab-bg nav-justified">
                  {/* <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "1",
                      })}
                      onClick={() => {
                        this.toggle3("1");
                      }}
                    >
                      Deal info
                    </NavLink>
                  </NavItem> */}
                   <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "5",
                      })}
                      onClick={() => {
                        this.toggle3("5");
                      }}
                    >
                      Overview
                    </NavLink>
                  </NavItem>

                 
              
                  <NavItem>
                         <NavLink
                    style={{ 
                      cursor: deal?.isInvestor ? "not-allowed" : "pointer", 
                      pointerEvents: deal?.isInvestor ? "none" : "auto", 
                      opacity: deal?.isInvestor ? 0.1 : 1 
                    }}
                    className={classnames({
                      active: this.state.activeTab3 === "2",
                    })}
                    onClick={() => {
                      if (!deal?.isInvestor) {
                        this.toggle3("2");
                      }
                    }}
                  >
                    To-do checklist
                  </NavLink>
                   
                  </NavItem>

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "3",
                      })}
                      onClick={() => {
                        this.toggle3("3");
                      }}
                    >
                      Mortgage info
                    </NavLink>
                  </NavItem>

                  <NavItem>
                    <NavLink
                      style={{ cursor: "pointer" }}
                      className={classnames({
                        active: this.state.activeTab3 === "4",
                      })}
                      onClick={() => {
                        this.toggle3("4");
                      }}
                    >
                     Lawyer info
                    </NavLink>
                  </NavItem>

                   <NavItem>
                    
                         <NavLink
                          style={{ 
                            cursor: deal?.isInvestor ? "pointer" : "not-allowed", 
                            pointerEvents: deal?.isInvestor ? "auto" : "none", 
                            opacity: deal?.isInvestor ? 1 : 0.1 
                          }}
                          className={classnames({
                            active: this.state.activeTab3 === "6",
                          })}
                          onClick={() => {
                            if (deal?.isInvestor) {
                              this.toggle3("6");
                            }
                          }}
                      >
                    Payment Schedule
                    </NavLink>
                  </NavItem>
                </Nav>
                <TabContent
                  activeTab={this.state.activeTab3}
                  className="p-3 text-muted"
                >
                  <TabPane tabId="1">
                      <table className="align-middle mb-0 table">
                        <tbody>
                          <tr>
                            <th scope="row">Start date</th>
                            <td>{deal?.startDate ? <Moment format="MMM, d, YYYY">{deal?.startDate}</Moment>: '' }</td>
                          </tr>
                          <tr>
                            <th scope="row">End date</th>
                            <td>{deal?.endDate ? <Moment format="MMM, d, YYYY">{deal?.endDate}</Moment>: '' }</td>
                          </tr>
                          <tr>
                            <th scope="row">Address</th>
                            <td>{deal?.propertyAddress || ''}</td>
                          </tr>
                          <tr>
                            <th scope="row">Price</th>
                            <td>${deal?.transactionAmount?.toFixed(2) || "0.00"}</td>
                          </tr>
                          <tr>
                            <th scope="row">Commission Type</th>
                            <td>{this.getCommType(deal?.commissionTypeId)}</td>
                          </tr>
                          <tr>
                            <th scope="row">Commission Value</th>
                            <td>${deal?.commissionValue?.toFixed(2) || "0.00"}</td>
                          </tr>
                          <tr>
                            <th scope="row">Notes</th>
                            <td></td>
                          </tr>
                        </tbody>
                      </table>

                  </TabPane>
                  <TabPane tabId="5">
                    { deal?.isBuyer ?  
                    <>
                      <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                            <Row>
                              <Col>
                                <span>
                                  <strong>Agreement:</strong> {deal?.lastAgreementDate ? <Moment format="DD MMM YYYY">{deal?.lastAgreementDate}</Moment> : ''}
                                </span>
                              </Col>

                              <Col>
                                <span><strong>Deal Id:</strong> {generatedDealId}</span>
                              </Col>

                              <Col>
                                <span>
                                  <strong>Type:</strong> {deal?.isBuyer
                                    ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                    : ""}

                                  {deal?.isSeller
                                    ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                    : ""}
                                </span>
                              </Col>
                            </Row>
                          
                      </Alert>
                     
                    <table className="table  deal-info-table">
                     
                      <tbody>
                         <tr>
                            <th scope="row">Address  : <span>{deal?.contactAddress}</span></th>
                           
                            <th scope="row">Listed price: <span> ${buyerListing?.listedPrice}</span>
                           
                            </th>
                          </tr>
                          {offerDetail?.id > 0 ? (
                            <>
                           <tr>
                            <th scope="row" colSpan={4} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} /> Offer details</th>
                          </tr>
                          <tr>
                            <th scope="row">Receive date :  <span>{ offerDetail?.lastAgreementDate ? <Moment format="DD MMM YYYY">{offerDetail?.lastAgreementDate}</Moment> : '' }</span></th>
                           
                            <th scope="row">Offer price: <span>{ offerDetail?.offerPrice || '' }</span> </th>
                            
                           
                          </tr>
                          <tr>
                             <th scope="row">Deposit  amount: <span>{ offerDetail?.deposit || '' }</span> </th>
                            <th scope="row">Closing date:  <span>{ offerDetail?.closingDate ? <Moment format="DD MMM YYYY">{offerDetail?.closingDate}</Moment> : '' }</span></th>
                            
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2}><span style={{marginLeft:0}}>Condition/clauses</span></th>
                           
                          </tr>
                          <tr>
                             <th scope="row" colSpan={2}>
                                      <div>
                                        {offerDetail?.clientDealConditionStates?.map((condition, index) => (
                                          <div className="form-check form-check-inline" key={index}>
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`condition-${index}`}
                                              value=""
                                              checked={condition.status}
                                            />
                                            <label className="form-check-label" htmlFor={`condition-${index}`}>
                                              {condition.clientDealConditionTitle || `Condition ${condition.clientDealConditionId}`}
                                            </label>
                                          </div>
                                        ))}
                                      </div>

                                    </th>

                           
                          </tr>
                           <tr>
                            <th scope="row" colSpan={2}><span style={{marginLeft:0}}>Special requests/clauses/conditions/notes</span></th>
                           
                          </tr>
                           <tr>
                            <th scope="row" colSpan={2}><span style={{marginLeft:0}}> {offerDetail?.notes}</span></th>
                           
                          </tr>
                          </>
                          ):(
                            <>
                            <tr>
                            <th scope="row" colSpan={2}>
                              <Alert color="danger">Deal status: {this.getStatus(deal?.clientEngagementStatus)}</Alert>
                              </th>
                              </tr>
                            </>
                          )}

                     
                      </tbody>
                    </table>

                    
                    </>
                 : deal?.isSeller ?
                   <>
                      <Alert color="" role="alert" style={{ fontSize: 15, color: '#000', border: '1px solid #ccc', borderRadius: 12 }}>
                            <Row>
                              <Col>
                                <span>
                                  <strong>Agreement:</strong> {deal?.lastAgreementDate ? <Moment format="DD MMM YYYY">{deal?.lastAgreementDate}</Moment> : ''}
                                </span>
                              </Col>

                              <Col>
                                <span> <strong>Deal Id:</strong> {generatedDealId}</span>
                              </Col>

                              <Col>
                                <span>
                                  <strong>Type:</strong> {deal?.isBuyer
                                    ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                    : ""}

                                  {deal?.isSeller
                                    ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                                    : ""}
                                </span>
                              </Col>
                            </Row>
                          
                      </Alert>
                     
                    <table className="table  deal-info-table">
                     
                      <tbody>
                         <tr>
                            <th scope="row">Address  : <span>{deal?.contactAddress}</span></th>
                           
                            <th scope="row">Listed price: <span> 
                              <CurrencyFormat
                                    value={sellerListing?.clientListing?.salePrice || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={deal?.currencyCode ? deal.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  /></span>
                              
                              
                           
                            </th>
                          </tr>
                          {offerDetail?.id > 0 ? (
                            <>
                           <tr>
                            <th scope="row" colSpan={4} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} /> Offer details</th>
                          </tr>
                          <tr>
                            <th scope="row">Receive date :  <span>{ offerDetail?.offerDate ? <Moment format="DD MMM YYYY">{offerDetail?.offerDate}</Moment> : '' }</span></th>
                           
                            <th scope="row">Offer price: <span> <CurrencyFormat
                                    value={offerDetail?.offerPrice || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={deal?.currencyCode ? deal.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  /></span> </th>
                            
                           
                          </tr>
                          <tr>
                             <th scope="row">Deposit  amount: <span>
                               <CurrencyFormat
                                    value={offerDetail?.deposit || 0}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={deal?.currencyCode ? deal.currencyCode + " " : "$"}
                                    decimalScale={2}
                                    fixedDecimalScale={true}
                                  />
                              
                              </span> </th>
                            <th scope="row">Closing date:  <span>{ offerDetail?.closingDate ? <Moment format="DD MMM YYYY">{offerDetail?.closingDate}</Moment> : '' }</span></th>
                            
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2}><span style={{marginLeft:0}}><strong>Condition/clauses</strong></span></th>
                           
                          </tr>
                          <tr>
                             <th scope="row" colSpan={2}>
                                      <div>
                                        {offerDetail?.clientDealConditionStates?.map((condition, index) => (
                                          <div className="form-check form-check-inline" key={index}>
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              id={`condition-${index}`}
                                              value=""
                                              checked={condition.status}
                                            />
                                            <label className="form-check-label" htmlFor={`condition-${index}`}>
                                              {condition.clientDealConditionTitle || `Condition ${condition.clientDealConditionId}`}
                                            </label>
                                          </div>
                                        ))}
                                      </div>

                                    </th>

                           
                          </tr>
                           <tr>
                            <th scope="row" colSpan={2}><span style={{marginLeft:0}}><strong>Special requests/clauses/conditions/notes</strong></span></th>
                           
                          </tr>
                           <tr>
                            <th scope="row" colSpan={2}><span style={{marginLeft:0}}> {offerDetail?.notes}</span></th>
                           
                          </tr>
                          </>
                          ):(
                            <>
                            <tr>
                            <th scope="row" colSpan={2}>
                              <Alert color="danger">Deal status: {this.getStatus(deal?.clientEngagementStatus)}</Alert>
                              </th>
                              </tr>
                            </>
                          )}

                     
                      </tbody>
                    </table>

                    
                    </>
               
                  :
                  <>
                  

                  <table className="table  deal-info-table ">
                     
                     <tbody>
                         <tr>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Deal Type: <span>Investor</span></th>
                          
                            
                           
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2}>Address : <span>{deal?.contactAddress}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Principal applicant)</th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name:<span>{deal?.clientName}</span></th>
                          
                           <th scope="row">Email: <span>{ deal?.clientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ deal?.clientPhone}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Secondary)</th>
                         </tr>
                         <tr>
                           <th scope="row">Name: <span>{deal?.secondaryClientName}</span></th>
                          
                           <th scope="row">Email: <span>{ deal?.secondaryClientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{deal?.secondaryClientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ deal?.secondaryClientPhone}</span></th>
                          
                         </tr>
                    
                     <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Project Detail</th>
                         </tr>
                      <tr>
                        <th scope="row">Project Name: <span>{ investorListing?.project?.projectName }</span></th>
                       
                     
                        <th scope="row">Unit: <span>{ investorListing?.projects[0]?.selectedOptionText }</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Builder: <span>{ investorListing?.builder?.builderName }</span></th>
                       
                     
                        <th scope="row">Cost: <span>{'$'.investorListing?.projects[0]?.unitCost || ''}</span></th>
                       
                      </tr>

                      <tr>
                        <th scope="row">Inside Sq.ft: <span>{investorListing?.projects[0]?.insideSqFt}</span></th>
                       
                     
                        <th scope="row">Outside Sq.ft: <span>{investorListing?.projects[0]?.outsideSqFt}</span></th>
                       
                      </tr>
                     
                      </tbody>
                    </table>
                  </>
                  }

                  </TabPane>
                   <TabPane tabId="51">
                    { deal?.isBuyer ?  
                    <>
                  
                    <table className="table  deal-info-table">
                     
                      <tbody>
                          <tr>
                            <th scope="row">Deal Id : <span>{generatedDealId}</span></th>
                           
                            <th scope="row">Deal Type: 
                            <span>
                            {deal?.isBuyer
                                    ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                    : ""}

                            {deal?.isSeller
                              ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                              : ""}
                            </span>
                            </th>
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2}>Address:  <span>{deal?.contactAddress}</span></th>
                            
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} />Agent Info</th>
                           
                          </tr>
                          <tr>
                            <th scope="row">Name: <span>{deal?.agentName}</span></th>
                            
                            <th scope="row">Business Name: <span>{ deal?.agentOfficeName }</span></th>
                           
                          </tr>
                          <tr>
                            <th scope="row">Phone: <span>{deal?.agentMobile}</span></th>
                           
                            <th scope="row">Email: <span>{ deal?.agentEmail }</span></th>
                           
                          </tr>
                          <tr>
                            <th scope="row" colSpan={2} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} /> Client Info</th>
                          </tr>
                          <tr>
                            <th scope="row">Name: <span>{deal?.clientName}</span></th>
                           
                            <th scope="row">Email: <span>{ deal?.clientEmail}</span></th>
                          
                          </tr>
                          <tr>
                            <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>
                           
                            <th scope="row">Secondary Phone: <span>{ deal?.clientPhone}</span></th>
                           
                          </tr>
                       <tr>
                            <th scope="row" colSpan={4} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} /> Listing Details</th>
                          </tr>     
                      <tr>
                        <th scope="row">MLS ID: <span>{buyerListing?.mlsId} {buyerListing?.mlsurl ? <span className="float-end"><a href={buyerListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : '' }</span></th>
                     
                         <th scope="row">Is Interested: <span>{buyerListing?.isInterested ? 'Yes' : 'No'}</span></th>
                      
                      </tr>
                    
                      <tr>
                        <th scope="row">Listing Price: <span>${buyerListing?.listedPrice}</span></th>
                       
                      
                        <th scope="row">Listing Type: <span>{buyerListing?.listingType}</span></th>
                        
                      </tr>
                      <tr>
                        <th scope="row">Bedroom : <span>{buyerListing?.listingBedroom}</span></th>
                       
                    
                        <th scope="row">Bathroom: <span>{buyerListing?.listingBedroom}</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Parking: <span>{buyerListing?.listingParking}</span></th>
                       
                     
                        <th scope="row">Sq. Ft: <span>{buyerListing?.listingSqFt}</span></th>
                      
                    </tr>
                    <tr>
                        <th scope="row">Address: <span>{buyerListing?.listingAddress}</span></th>
                     
                     
                        <th scope="row">City: <span>{buyerListing?.listingCity}</span></th>
                     
                      </tr>

                     
                      </tbody>
                    </table>

                    
                    </>
                 : deal?.isSeller ?
                 <>
                  

                    <table className="table  deal-info-table ">
                     
                     <tbody>
                         <tr>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Deal Type: 
                            <span>
                           {deal?.isBuyer
                                   ? `Buyer${deal?.buyerType ? ` - ${this.getBuyerType(deal?.buyerType)}` : ""}`
                                   : ""}

                           {deal?.isSeller
                             ? `Seller${deal?.sellerType ? ` - ${this.getSellerType(deal?.sellerType)}` : ""}`
                             : ""}
                             </span>
                           </th>
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2}>Address : <span>{deal?.contactAddress}</span></th>
                           
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} /> Agent Info</th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name : <span>{deal?.agentName}</span></th>
                          
                           <th scope="row">Business Name: <span>{ deal?.agentOfficeName }</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Phone: <span>{deal?.agentMobile}</span></th>
                          
                           <th scope="row">Email: <span>{ deal?.agentEmail }</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} /> Client Info</th>
                         </tr>
                         <tr>
                           <th scope="row">Name: <span>{deal?.clientName}</span></th>
                          
                           <th scope="row">Email: <span>{ deal?.clientEmail}</span></th>
                         
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ deal?.clientPhone}</span></th>
                          
                         </tr>
                         <tr>
                          <th scope="row" colSpan={2} style={{color:'#9d3881', fontSize:16}}><img src={pointerDown} className="me-2" style={{width:30}} /> Listing Detail</th>
                          </tr>
                           <tr>
                        <th scope="row">Listing Id: <span>{sellerListing?.clientListing?.mlsId} {sellerListing?.clientListing?.mlsurl ? <span className="float-end"><a href={sellerListing?.clientListing?.mlsurl} target="_blank" rel="noreferrer"><i className="bx bx-link-external font-size-20"></i></a></span> : '' }</span></th>
                       
                    
                        <th scope="row">Listing Price: <span>{ sellerListing?.clientListing?.salePrice ? '$'+sellerListing?.clientListing?.salePrice : '' }</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Showing Date: <span>{sellerListing?.showingDate ? <Moment format="DD MMM YYYY">{sellerListing?.showingDate}</Moment> : ''}</span></th>
                       
                     
                        <th scope="row">Start Time: <span>{sellerListing?.startTime ? <Moment format="hh:ss A">{sellerListing?.startTime}</Moment> : ''}</span></th>
                       
                     
                       
                      </tr>
                      <tr>
                         <th scope="row">End Time: <span>{sellerListing?.endTime ? <Moment format="hh:ss A">{sellerListing?.endTime}</Moment> : ''}</span></th>
                       
                        <th scope="row">Agent Name: <span>{sellerListing?.agentName}</span></th>
                       
                     </tr>
                      <tr>
                        <th scope="row">Agent Organization: <span>{sellerListing?.agentOrganization}</span></th>
                       
                     
                        <th scope="row">Agent Contact : <span>{sellerListing?.agentContact}</span></th>
                       
                       </tr>
                         <tr>
                        <th scope="row">Agent Email: <span>{sellerListing?.agentEmail}</span></th>
                      
                         <th scope="row"></th>
                       
                      </tr>
                     </tbody>
                     </table>

                     
                    </>
                  :
                  <>
                  

                  <table className="table  deal-info-table ">
                     
                     <tbody>
                         <tr>
                           <th scope="row">Deal Id: <span>{generatedDealId}</span></th>
                          
                           <th scope="row">Deal Type: <span>Investor</span></th>
                          
                            
                           
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2}>Address : <span>{deal?.contactAddress}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Principal applicant)</th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Name:<span>{deal?.clientName}</span></th>
                          
                           <th scope="row">Email: <span>{ deal?.clientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{deal?.clientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ deal?.clientPhone}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Client Info (Secondary)</th>
                         </tr>
                         <tr>
                           <th scope="row">Name: <span>{deal?.secondaryClientName}</span></th>
                          
                           <th scope="row">Email: <span>{ deal?.secondaryClientEmail}</span></th>
                          
                         </tr>
                         <tr>
                           <th scope="row">Primary Phone: <span>{deal?.secondaryClientMobile}</span></th>
                          
                           <th scope="row">Secondary Phone: <span>{ deal?.secondaryClientPhone}</span></th>
                          
                         </tr>
                    
                     <tr>
                           <th scope="row" colSpan={2} style={{color:'#9d3881'}}>Project Detail</th>
                         </tr>
                      <tr>
                        <th scope="row">Project Name: <span>{ investorListing?.project?.projectName }</span></th>
                       
                     
                        <th scope="row">Unit: <span>{ investorListing?.projects[0]?.selectedOptionText }</span></th>
                       
                      </tr>
                      <tr>
                        <th scope="row">Builder: <span>{ investorListing?.builder?.builderName }</span></th>
                       
                     
                        <th scope="row">Cost: <span>{'$'.investorListing?.projects[0]?.unitCost || ''}</span></th>
                       
                      </tr>

                      <tr>
                        <th scope="row">Inside Sq.ft: <span>{investorListing?.projects[0]?.insideSqFt}</span></th>
                       
                     
                        <th scope="row">Outside Sq.ft: <span>{investorListing?.projects[0]?.outsideSqFt}</span></th>
                       
                      </tr>
                     
                      </tbody>
                    </table>
                  </>
                  }

                  </TabPane>
                  <TabPane tabId="2">
                  <Formik
                    enableReinitialize={true}
                    initialValues={{
                      selectedTasks: this.state.selectedChecklistIds || [],
                      
                    }}
                    validationSchema={Yup.object().shape({})}
                       onSubmit={(values) => {
                                        const closingCheckLists = (values.selectedTasks || []).map((taskId) => ({
                                          clientClosingCheckListId: parseInt(taskId, 10),
                                          clientListingId: 0,
                                          clientDealId: parseInt(deal?.clientEngagementId),
                                          clientId: parseInt(localStorage.getItem("userId")),
                                          agentId: parseInt(localStorage.getItem("agentId")),
                                          status: true,
                                          isActive: true,
                                        }));
                                       // toast.loading("Please wait...");
                                        const payload = deal?.isBuyer
                                          ? { buyerClosingCheckLists: closingCheckLists }
                                          : { sellerClosingCheckLists: closingCheckLists};
                                            
                                              toast.loading("Please wait...")
                                              const url = deal?.isBuyer ? `ClientBuyerClosingCheckList/bulkadd` : `ClientSellerClosingCheckList/bulkadd`;
                                              post(url, payload)
                                              .then((data) => {
                                                if (data.success) {
                                                  toast.dismiss();
                                                  toast.success("Saved successfully!");
                                                  this.toggleManage();
                                                } else {
                                                  toast.dismiss();
                                                  toast.error("Something went wrong while saving.");
                                                }
                                              })
                                              .catch((error) => {
                                                console.error("Error:", error);
                                                toast.dismiss();
                                                 this.toggleManage();
                                                //toast.error(`Error updating checklist: ${error.message}`);
                                              });
                                         
                                              
                                    }}
                  >
  {({ values, setFieldValue }) => (
    <Form className="needs-validation">
      <div className="accordion accordion-flush" id="accordionFlushExample">
        {groupedChecklist && Object.keys(groupedChecklist).length > 0 ? (
          <>
            {Object.entries(groupedChecklist).map(([category, tasks], index) => (
              <div className="accordion-item" key={category}>
                <h2 className="accordion-header" id={`heading-${index}`}>
                  <button
                    className={`accordion-button fw-medium ${this.state.activeCategories[category] ? "" : "collapsed"}`}
                    type="button"
                    onClick={() => this.toggleCategory(category)}
                    style={{ cursor: "pointer" }}
                  >
                    {category}
                  </button>
                </h2>

                <Collapse isOpen={this.state.activeCategories[category]} className="accordion-collapse">
                  <div className="accordion-body">
                    {tasks.length > 0 ? (
                      <Row>
                        {tasks.map((task) => (
                          <Col md="12" key={task.id}>
                            <FormGroup className="mb-3">
                              <input
                                name="selectedTasks"
                                className="form-check-input me-2"
                                type="checkbox"
                                id={`task_${task.id}`}
                                checked={values.selectedTasks.includes(task.id)}
                                onChange={(e) => {
                                  const checked = e.target.checked;
                                  setFieldValue(
                                    "selectedTasks",
                                    checked
                                      ? [...values.selectedTasks, task.id]
                                      : values.selectedTasks.filter((id) => id !== task.id)
                                  );
                                }}
                              />
                              <Label htmlFor={`task_${task.id}`} className="form-check-label">
                                {task.checkListTask}
                              </Label>
                            </FormGroup>
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <p className="text-muted">No tasks available</p>
                    )}
                  </div>
                </Collapse>
              </div>
            ))}

           
            <button type="submit" className="btn btn-primary w-md float-end" style={{ marginTop: "10px" }}>
              Submit
            </button>
          </>
        ) : null}
      </div>
    </Form>
  )}
                  </Formik>

                  </TabPane>
                  <TabPane tabId="3">
                        <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                              id:mortgageContact?.id || 0,
                                              clientProfessionalContactId:mortgageContact?.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
                                              dealId: parseInt(deal?.clientEngagementId),
                                              professionalContactTypeId: 2,
                                              title:mortgageContact?.title || '',
                                              notes:mortgageContact?.notes || '',
                                              contactFName: mortgageContact?.contactFName || '',
                                              contactLName: mortgageContact?.contactLName || '',
                                              clientId: parseInt(localStorage.getItem('userId')),
                                              agentId: parseInt(localStorage.getItem('agentId')),
                                              primaryContactId:mortgageContact?.primaryContactId || 0,
                                              addressId:mortgageContact?.addressId || 0,
                                              isActive:true,
                                              organizationName: mortgageContact?.organizationName || '',
                                              email: mortgageContact?.primaryContact?.email || '',
                                              phone: mortgageContact?.primaryContact?.phone || '',
                                              mobile: mortgageContact?.primaryContact?.mobile || '',
                                             
                                              fullAddress:mortgageContact?.clientProfessionalContactAddress?.fullAddress || '',
                                              addressLine1:mortgageContact?.clientProfessionalContactAddress?.addressLine1 || '',
                                              addressLine2:mortgageContact?.clientProfessionalContactAddress?.addressLine2 || '',
                                              nearestIntersection:mortgageContact?.clientProfessionalContactAddress?.nearestIntersection || '',
                                              city:mortgageContact?.clientProfessionalContactAddress?.city || '',
                                              province:mortgageContact?.clientProfessionalContactAddress?.province || '',
                                              postal:mortgageContact?.clientProfessionalContactAddress?.postal || '',
                                              country:mortgageContact?.clientProfessionalContactAddress?.country || '',
                                              longitude:mortgageContact?.clientProfessionalContactAddress?.longitude || '',
                                              latitude:mortgageContact?.clientProfessionalContactAddress?.latitude || '', 
                                              
                                             
                                            }}
                                            validationSchema={Yup.object().shape({
                                              title: Yup.string().required("This Field in required"),
                                              contactFName: Yup.string().required("This Field in required"),
                                              contactLName: Yup.string().required("This Field in required"),
                                              organizationName: Yup.string().required('This field is required'),
                                              email: Yup.string().email('Invalid email').required('This Field in required'),
                                              mobile: Yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Enter number is not valid').required('This is required'),
                                              phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                                            })}
                    
                                            onSubmit={this.handleSubmitMortgage}
                                          >
                                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                                              <Form
                                                className="needs-validation"
                                              >
                                                <Row>
                                                <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="title">
                                                        {this.props.t("Title *")}
                                                      </Label>
                                                      <Field as="select" name="title" 
                                                       onChange={handleChange}
                                                      className={
                                                        "form-control" +
                                                        (errors.title && touched.title
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      id="title">
                                                          <option value="">Select</option>
                                                          <option value="Mr">Mr</option>
                                                          <option value="Mrs">Mrs</option>
                                                          <option value="Miss">Miss</option>
                                                          <option value="Dr">Dr</option>
                                                          <option value="Prof">Prof</option>

                                                      </Field>
                                                      <ErrorMessage
                                                        name="title"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactFName">
                                                        {this.props.t("First Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactFName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactFName && touched.contactFName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactFName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactFName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactLName">
                                                        {this.props.t("Last Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactLName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactLName && touched.contactLName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactLName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactLName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="organizationName">
                                                        {this.props.t("Organization Name *")}
                                                      </Label>
                                                      <Field
                                                        name="organizationName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.organizationName && touched.organizationName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="organizationName"
                                                      />
                                                      <ErrorMessage
                                                        name="organizationName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="8">
                                                            <FormGroup className="mb-3">
                                                              <Label htmlFor="fullAddress">
                                                                {this.props.t("Address")}
                                                              </Label>
                    
                    
                                                              <PlacesAutocomplete
                                                                 value={values.fullAddress}
                                                                 onChange={(value) => setFieldValue('fullAddress', value)}
                                                                onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                                              >
                                                           {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                      <div>
                                                                        <input
                                                                          {...getInputProps({
                                                                            placeholder: 'Enter Address...',
                                                                            className: 'form-control',
                                                                          
                                                                          })}
                                                                        />
                                                                        <div className="">
                                                                          {loading ? <div>Loading...</div> : null}
                    
                                                                          {suggestions.map((suggestion, i) => {
                                                                            const className = suggestion.active
                                                                              ? 'suggestion-item--active'
                                                                              : 'suggestion-item';
                                                                            const style = suggestion.active
                                                                              ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                              : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                    
                                                                            return (
                                                                              <div
                                                                              key={i}
                                                                                {...getSuggestionItemProps(suggestion, {
                                                                                  style,
                                                                                })}
                                                                              >
                                                                                {suggestion.description}
                                                                              </div>
                                                                            );
                                                                          })}
                                                                        </div>
                                                                      </div>
                                                                    )}
                                                                  </PlacesAutocomplete>
                    
                    
                                                            </FormGroup>
                                                          </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="email">
                                                        {this.props.t("Email *")}
                                                      </Label>
                                                      <Field
                                                        name="email"
                                                        type="text"
                                                        
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.email && touched.email
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="email"
                                                      />
                                                      <ErrorMessage
                                                        name="email"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                 
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="mobile">
                                                        {this.props.t("Mobile *")}
                                                      </Label>
                                                      <Field
                                                        name="mobile"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.mobile && touched.mobile
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="mobile"
                                                      />
                                                      <ErrorMessage
                                                        name="mobile"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phone">
                                                        {this.props.t("Secondary Phone")}
                                                      </Label>
                                                      <Field
                                                        name="phone"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phone && touched.phone
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phone"
                                                      />
                                                      <ErrorMessage
                                                        name="phone"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phoneExt">
                                                        {this.props.t("Ext")}
                                                      </Label>
                                                      <Field
                                                        name="phoneExt"
                                                        type="text"
                                                        //value={values.phone}
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phoneExt && touched.phoneExt
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phoneExt"
                                                      />
                                                      <ErrorMessage
                                                        name="phoneExt"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col> 
                                              
                                                 
                                                 
                                               
                                                 
                                                     
                                                
                                                </Row>
                                        
                                                <Row>
                                                  <Col md="12">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="notes">
                                                        {this.props.t("Notes ")}
                                                      </Label>
                                                      <Field
                                                        name="notes"
                                                        onChange={handleChange}
                                                        as="textarea"
                    
                                                        className="form-control"
                    
                                                        id="notes"
                    
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                    
                    
                                                </Row>
                    
                    
                    
                    
                    
                    
                                                <div><button type="submit" className="btn btn-primary w-md float-end">Update</button></div>
                    
                                              </Form>
                                            )}
                                          </Formik>
                  </TabPane>
                  <TabPane tabId="4">
                        <Formik
                                            enableReinitialize={true}
                                            initialValues={{
                                              id:legalContact?.id || 0,
                                              clientProfessionalContactId:legalContact?.clientProfessionalContactId || '3f9432c8-2c15-46c9-81f7-aff0552eb84a',
                                              dealId: parseInt(deal?.clientEngagementId),
                                              professionalContactTypeId: 1,
                                              title:legalContact?.title || '',
                                              notes:legalContact?.notes || '',
                                              contactFName: legalContact?.contactFName || '',
                                              contactLName: legalContact?.contactLName || '',
                                              clientId: parseInt(localStorage.getItem('userId')),
                                              agentId: parseInt(localStorage.getItem('agentId')),
                                              primaryContactId:legalContact?.primaryContactId || 0,
                                              addressId:legalContact?.addressId || 0,
                                              isActive:true,
                                              organizationName: legalContact?.organizationName || '',
                                              email: legalContact?.primaryContact?.email || '',
                                              phone: legalContact?.primaryContact?.phone || '',
                                              mobile: legalContact?.primaryContact?.mobile || '',
                                             
                                              fullAddress:legalContact?.clientProfessionalContactAddress?.fullAddress || '',
                                              addressLine1:legalContact?.clientProfessionalContactAddress?.addressLine1 || '',
                                              addressLine2:legalContact?.clientProfessionalContactAddress?.addressLine2 || '',
                                              nearestIntersection:legalContact?.clientProfessionalContactAddress?.nearestIntersection || '',
                                              city:legalContact?.clientProfessionalContactAddress?.city || '',
                                              province:legalContact?.clientProfessionalContactAddress?.province || '',
                                              postal:legalContact?.clientProfessionalContactAddress?.postal || '',
                                              country:legalContact?.clientProfessionalContactAddress?.country || '',
                                              longitude:legalContact?.clientProfessionalContactAddress?.longitude || '',
                                              latitude:legalContact?.clientProfessionalContactAddress?.latitude || '', 
                                              
                                             
                                            }}
                                            validationSchema={Yup.object().shape({
                                              title: Yup.string().required("This Field in required"),
                                              contactFName: Yup.string().required("This Field in required"),
                                              contactLName: Yup.string().required("This Field in required"),
                                              organizationName: Yup.string().required('This field is required'),
                                              email: Yup.string().email('Invalid email').required('This Field in required'),
                                              mobile: Yup.string().matches(/^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/, 'Enter number is not valid').required('This is required'),
                                              phone: Yup.string().matches(/(?:\(?\+\d{2}\)?\s*)?\d+(?:[ -]*\d+)*$/, 'Enter number is not valid'),
                                            })}
                    
                                            onSubmit={this.handleSubmitLowyer}
                                          >
                                            {({ errors, touched, values, handleChange, setFieldValue }) => (
                                              <Form
                                                className="needs-validation"
                                              >
                                               <Row>
                                                <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="title">
                                                        {this.props.t("Title *")}
                                                      </Label>
                                                      <Field as="select" name="title" 
                                                       onChange={handleChange}
                                                      className={
                                                        "form-control" +
                                                        (errors.title && touched.title
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                      id="title">
                                                          <option value="">Select</option>
                                                          <option value="Mr">Mr</option>
                                                          <option value="Mrs">Mrs</option>
                                                          <option value="Miss">Miss</option>
                                                          <option value="Dr">Dr</option>
                                                          <option value="Prof">Prof</option>

                                                      </Field>
                                                      <ErrorMessage
                                                        name="title"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactFName">
                                                        {this.props.t("First Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactFName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactFName && touched.contactFName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactFName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactFName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="5">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="contactLName">
                                                        {this.props.t("Last Name *")}
                                                      </Label>
                                                      <Field
                                                        name="contactLName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.contactLName && touched.contactLName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="contactLName"
                                                      />
                                                      <ErrorMessage
                                                        name="contactLName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="organizationName">
                                                        {this.props.t("Organization Name *")}
                                                      </Label>
                                                      <Field
                                                        name="organizationName"
                                                        type="text"
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.organizationName && touched.organizationName
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="organizationName"
                                                      />
                                                      <ErrorMessage
                                                        name="organizationName"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="8">
                                                            <FormGroup className="mb-3">
                                                              <Label htmlFor="fullAddress">
                                                                {this.props.t("Address")}
                                                              </Label>
                    
                    
                                                              <PlacesAutocomplete
                                                                 value={values.fullAddress}
                                                                 onChange={(value) => setFieldValue('fullAddress', value)}
                                                                onSelect={(value) => this.handlePlaceSelected(value, setFieldValue)}
                                                              >
                                                           {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                                                      <div>
                                                                        <input
                                                                          {...getInputProps({
                                                                            placeholder: 'Enter Address...',
                                                                            className: 'form-control',
                                                                          
                                                                          })}
                                                                        />
                                                                        <div className="">
                                                                          {loading ? <div>Loading...</div> : null}
                    
                                                                          {suggestions.map((suggestion, i) => {
                                                                            const className = suggestion.active
                                                                              ? 'suggestion-item--active'
                                                                              : 'suggestion-item';
                                                                            const style = suggestion.active
                                                                              ? { backgroundColor: '#007BFF', color: '#fff', cursor: 'pointer', padding: '10px' }
                                                                              : { backgroundColor: '#fff', cursor: 'pointer', padding: '10px' };
                    
                                                                            return (
                                                                              <div
                                                                              key={i}
                                                                                {...getSuggestionItemProps(suggestion, {
                                                                                  style,
                                                                                })}
                                                                              >
                                                                                {suggestion.description}
                                                                              </div>
                                                                            );
                                                                          })}
                                                                        </div>
                                                                      </div>
                                                                    )}
                                                                  </PlacesAutocomplete>
                    
                    
                                                            </FormGroup>
                                                          </Col>
                                                  <Col md="4">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="email">
                                                        {this.props.t("Email *")}
                                                      </Label>
                                                      <Field
                                                        name="email"
                                                        type="text"
                                                        
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.email && touched.email
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="email"
                                                      />
                                                      <ErrorMessage
                                                        name="email"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                 
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="mobile">
                                                        {this.props.t("Mobile *")}
                                                      </Label>
                                                      <Field
                                                        name="mobile"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.mobile && touched.mobile
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="mobile"
                                                      />
                                                      <ErrorMessage
                                                        name="mobile"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="3">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phone">
                                                        {this.props.t("Secondary Phone")}
                                                      </Label>
                                                      <Field
                                                        name="phone"
                                                        type="text"
                                                       
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phone && touched.phone
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phone"
                                                      />
                                                      <ErrorMessage
                                                        name="phone"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col>
                                                  <Col md="2">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="phoneExt">
                                                        {this.props.t("Ext")}
                                                      </Label>
                                                      <Field
                                                        name="phoneExt"
                                                        type="text"
                                                        //value={values.phone}
                                                        onChange={handleChange}
                                                        className={
                                                          "form-control" +
                                                          (errors.phoneExt && touched.phoneExt
                                                            ? " is-invalid"
                                                            : "")
                                                        }
                                                        id="phoneExt"
                                                      />
                                                      <ErrorMessage
                                                        name="phoneExt"
                                                        component="div"
                                                        className="invalid-feedback"
                                                      />
                                                    </FormGroup>
                                                  </Col> 
                                              
                                                 
                                                 
                                               
                                                 
                                                     
                                                
                                                </Row>
                                        
                                                <Row>
                                                  <Col md="12">
                                                    <FormGroup className="mb-3">
                                                      <Label htmlFor="notes">
                                                        {this.props.t("Notes ")}
                                                      </Label>
                                                      <Field
                                                        name="notes"
                                                        onChange={handleChange}
                                                        as="textarea"
                    
                                                        className="form-control"
                    
                                                        id="notes"
                    
                                                      />
                                                    </FormGroup>
                                                  </Col>
                    
                    
                    
                                                </Row>
                    
                    
                    
                    
                    
                    
                                                <div><button type="submit" className="btn btn-primary w-md float-end">Update</button></div>
                    
                                              </Form>
                                            )}
                                          </Formik>
                  </TabPane>
                  <TabPane tabId="6">
                      <Formik
                            enableReinitialize={true}
                            initialValues={{
                              agentClientTransactionPaymentSchedules: [
                                {
                                  projectId:deal?.projectId,
                                  engagementId:deal?.id,
                                  agentId: localStorage.getItem('agentId'),
                                  clientId: localStorage.getItem('userId'),
                                  dealRefId: deal?.dealRefId,
                                  paymentDate: '',
                                  paymentAmount: 0,
                                  bankDetail: '',
                                  chequeDetail: '',
                                  paymentNotificationBeforeDays: 0
                                }
                              ]
                            }}
                            validationSchema={Yup.object().shape({
                              agentClientTransactionPaymentSchedules: Yup.array().of(
                                Yup.object().shape({
                                  paymentDate: Yup.string().required("This is required"),
                                  paymentAmount: Yup.number()
                                    .typeError("Price should be a number")
                                    .required("Amount is required")
                                })
                              )
                            })}
                            onSubmit={this.handelSubmitPayment}
                          >
                            {({ errors, touched, values, handleChange, handleBlur, setFieldValue }) => (
                              <Form className="needs-validation">
                                <FieldArray
                                  name="agentClientTransactionPaymentSchedules"
                                  render={(arrayHelpers) => (
                                    <div>
                                      {values.agentClientTransactionPaymentSchedules.map((paymentSchedule, index) => (
                                        <div key={index}>
                                          <Row>
                                            <Col sm="2">
                                              <FormGroup className="mb-3">
                                                <Label htmlFor="paymentDate" className="label-text mt-3">
                                                  Date *
                                                </Label>
                                                <Flatpickr
                                                  className={`form-control ${
                                                    errors.agentClientTransactionPaymentSchedules?.[index]?.paymentDate &&
                                                    touched.agentClientTransactionPaymentSchedules?.[index]?.paymentDate
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  value={paymentSchedule.paymentDate}
                                                  onChange={(date) =>
                                                    setFieldValue(
                                                      `agentClientTransactionPaymentSchedules.${index}.paymentDate`,
                                                      date[0]
                                                    )
                                                  }
                                                  options={{
                                                    altInput: true,
                                                    altFormat: "Y-m-d",
                                                    dateFormat: "Y-m-d"
                                                  }}
                                                />
                                                <ErrorMessage
                                                  name={`agentClientTransactionPaymentSchedules.${index}.paymentDate`}
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </FormGroup>
                                            </Col>
                    
                                            <Col sm="2">
                                              <FormGroup className="mb-3">
                                                <Label htmlFor="paymentAmount" className="label-text mt-3">
                                                  Amount
                                                </Label>
                                                <input
                                                  type="text"
                                                  name={`agentClientTransactionPaymentSchedules.${index}.paymentAmount`}
                                                  value={paymentSchedule.paymentAmount}
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                                  className={`form-control ${
                                                    errors.agentClientTransactionPaymentSchedules?.[index]?.paymentAmount &&
                                                    touched.agentClientTransactionPaymentSchedules?.[index]?.paymentAmount
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                />
                                                <ErrorMessage
                                                  name={`agentClientTransactionPaymentSchedules.${index}.paymentAmount`}
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </FormGroup>
                                            </Col>
                    
                                            <Col sm="2">
                                              <FormGroup className="mb-3">
                                                <Label htmlFor="bankDetail" className="label-text mt-3">
                                                  Bank
                                                </Label>
                                                <input
                                                  type="text"
                                                  name={`agentClientTransactionPaymentSchedules.${index}.bankDetail`}
                                                  value={paymentSchedule.bankDetail}
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                                  className={`form-control ${
                                                    errors.agentClientTransactionPaymentSchedules?.[index]?.bankDetail &&
                                                    touched.agentClientTransactionPaymentSchedules?.[index]?.bankDetail
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                />
                                                <ErrorMessage
                                                  name={`agentClientTransactionPaymentSchedules.${index}.bankDetail`}
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </FormGroup>
                                            </Col>
                    
                                            <Col sm="2">
                                              <FormGroup className="mb-3">
                                                <Label htmlFor="chequeDetail" className="label-text mt-3">
                                                  Cheque #
                                                </Label>
                                                <input
                                                  type="text"
                                                  name={`agentClientTransactionPaymentSchedules.${index}.chequeDetail`}
                                                  value={paymentSchedule.chequeDetail}
                                                  onChange={handleChange}
                                                  onBlur={handleBlur}
                                                  className={`form-control ${
                                                    errors.agentClientTransactionPaymentSchedules?.[index]?.chequeDetail &&
                                                    touched.agentClientTransactionPaymentSchedules?.[index]?.chequeDetail
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                />
                                                <ErrorMessage
                                                  name={`agentClientTransactionPaymentSchedules.${index}.chequeDetail`}
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </FormGroup>
                                            </Col>
                    
                                            <Col sm="3">
                                              <FormGroup className="mb-3">
                                                <Label
                                                  htmlFor={`agentClientTransactionPaymentSchedules.${index}.paymentNotificationBeforeDays`}
                                                  className="label-text mt-3"
                                                >
                                                  Notify me
                                                </Label>
                                                <Field
                                                  as="select"
                                                  name={`agentClientTransactionPaymentSchedules.${index}.paymentNotificationBeforeDays`}
                                                  className={`form-control ${
                                                    errors.agentClientTransactionPaymentSchedules?.[index]?.paymentNotificationBeforeDays &&
                                                    touched.agentClientTransactionPaymentSchedules?.[index]?.paymentNotificationBeforeDays
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  onChange={handleChange}
                                                >
                                                  <option value="">Select</option>
                                                  <option value="1">1 day before</option>
                                                  <option value="7">1 week before</option>
                                                  <option value="14">2 weeks before</option>
                                                  <option value="30">1 month before</option>
                                                </Field>
                                                <ErrorMessage
                                                  name={`agentClientTransactionPaymentSchedules.${index}.paymentNotificationBeforeDays`}
                                                  component="div"
                                                  className="invalid-feedback"
                                                />
                                              </FormGroup>
                                            </Col>
                    
                                           
                                          </Row>
                                        </div>
                                      ))}
                                    </div>
                                  )}
                                />
                                <Col sm="2">
                                  <div className="clearfix">
                                    <button
                                      type="submit"
                                      className="btn btn-primary w-md"
                                      style={{ marginTop: 2 }}
                                    >
                                      Save
                                    </button>
                                  </div>
                                </Col>
                              </Form>
                            )}
                                          </Formik>
                                        <h5 style={{marginTop:40}}>Existing schedules</h5>
                                        <div className="table-responsive">
                                        <Table className="table align-middle table-nowrap mb-0">
                                          <thead>
                                            <tr>
                                              
                                         
                                             
                                              <th scope="col">Date </th>
                                             
                                              <th scope="col">Amount</th>
                                              <th scope="col">Bank</th>
                                              <th scope="col">Chq #</th>
                                              <th scope="col"></th>
                                              
                                             
                                            </tr>
                                          </thead>
                                          <tbody>
                                          {    this.state.paymentLists &&
                                                this.state.paymentLists
                                                  .map(payment =>
                                           <tr key={payment.id}>
                                          
                                             <td><Moment format="Do MMMM YYYY">{payment.paymentDate}</Moment></td>
                                            
                                             <td><CurrencyFormat value={payment.paymentAmount} displayType={'text'} thousandSeparator={true} prefix={'USD '} /></td>
                                             <td>{payment.bankDetail}</td>
                                             <td>{payment.chequeDetail}</td>
                                             <td><Link to="#" onClick={() => this.deletePayment(payment)} className=""><img src={deleteIcon} style={{width:30}} alt="" /></Link></td>
                                           </tr>
                                      )}
                                          </tbody>
                                        </Table>
                                        
                                        </div>
                  </TabPane>
                   <TabPane tabId="7">
                                      
                   </TabPane>
                </TabContent>
              </OffcanvasBody>
            </Offcanvas>
        </div>
      </React.Fragment>
    )
  }
}
Deals.propTypes = {
  t: PropTypes.any,
  history:PropTypes.object,
  loading:PropTypes.object

}
const mapStateToProps = ({ Showings }) => (
  {
     
     loading:Showings.loading

  })
const mapDispatchToProps = dispatch => ({
 
 
});
export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(Deals))
